import { defineStore } from 'pinia';
import replyLanguage from '../constants/replyLanguage';
import { saveUserProfile } from '../helpers/saveLang';

export const useReplyLanguageStore = defineStore('ReplyLanguage', {
	state: () => ({
		replyLanguage: '',
	}),

	getters: {
		getReplyLanguage(): string {
			const value = localStorage.getItem('replyLanguageID') ?? replyLanguage[0].id;
			this.replyLanguage = value;
			return this.replyLanguage;
		},
	},

	actions: {
		setReplyLanguage(value: string) {
			localStorage.setItem('replyLanguageID', value);
			this.replyLanguage = value;
			saveUserProfile();
		},
	},
});
